import { Component, Injectable, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Router } from '@angular/router';
import { AuthentificationService } from 'src/app/authentification/authentification.service';
import { RolesService } from 'src/app/authentification/roles.service';
import { LibellesService } from 'src/app/core/libelles.service';
import { AlertesService } from 'src/app/shared/alertes.service';
import { FiltreService } from 'src/app/shared/filtre.service';
import { erreursCroiseesLibelle, variableIdentifiante } from 'src/app/shared/questionnaire.metadata';
import { environment } from 'src/environments/environment';
import { FormulaireService } from '../formulaire.service';
import { ModeRenduService } from '../mode-rendu/mode-rendu.service';
import { SaisieService } from '../saisie.service';

@Injectable({
    providedIn: 'root'
})

@Component({
    selector: 'bis-questionnaire',
    templateUrl: './questionnaire.component.html',
    styleUrls: ['./questionnaire.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class QuestionnaireComponent implements OnInit {
    /** l’index de l’onglet en cours */
    public index: number = 0;
    /** formulaire du questionnaire en cours */
    public rootForm: UntypedFormGroup;
    /** Identifiant du questionnaire en cours */
    public identifiantQuestionnaire: string[];
    /** Map utile pour les contrôles blocants */
    public erreursMap: Map<string, string> = new Map<string, string>();
    /** Permet de gérer le champ de sélection d’un questionnaire */
    public formulaireSelecteur: UntypedFormGroup;
    /** Permet de remettre la bonne juridiction choisie précédemment */
    private precedenteJuridiction: String;
    // Permet de savoir si un questionnaire est déjà affiché
    public noCmpstAffiche = false;

    constructor(
        private formulaireService: FormulaireService,
        private authentificationService: AuthentificationService,
        private router: Router,
        public modeRendu: ModeRenduService,
        public rolesService: RolesService,
        public libelleService: LibellesService,
        public alertesService: AlertesService,
        public filtreService: FiltreService,
        public saisieService: SaisieService
    ) {
        // On charge la variable erreursMap
        this.erreursMap = erreursCroiseesLibelle;
    }

    async ngOnInit() {
        // Création de formulaireSelecteur
        this.formulaireSelecteur = new UntypedFormGroup({}, { updateOn: 'change' });
        variableIdentifiante.forEach((nomVariable) => {
            this.formulaireSelecteur.setControl(nomVariable, new UntypedFormControl(null,
                { validators: Validators.required }));
        });
        // On regarde si un questionnaire n’est pas déjà en mémoire :
        if (this.formulaireService.getRootForm()) {
            this.identifiantQuestionnaire = [];
            this.variableIdentifiante.forEach((nomVariable) => {
                this.identifiantQuestionnaire.push(this.formulaireService.getRootForm().get(nomVariable).value);
            });
            // On place le focus d'entree sur l'identifiant quand avec selecteur questionnaire
            setTimeout(() => {
                // Juridiction
                document.getElementById('input-select-ielst').focus();
            }, 200);
        } else {
            // On regarde si un élément de structure est fourni avec l’authentification
            // ? fermer la ressource lors de la destruction du component
            const ielst = await this.authentificationService.getIelst() as string;
            if (ielst) {
                // Traitement pour charger le questionnaire via l’ielst reçu
                this.identifiantQuestionnaire = [];
                this.identifiantQuestionnaire.push(ielst);
            } else if (!this.rolesService.isHabilite([RolesService.consultation.toLowerCase(), RolesService.gestionnaire.toLowerCase()])) {
                // Si aucun jeton et absence de droits suffisants pour accéder à la page, redirection
                console.error('Impossible d’identifier le questionnaire à afficher. Droits insuffisants');
                this.router.navigate(['/acces-interdit']);
            };
        }
        /*
        * À l’initialisation du composant, on récupère le questionnaire correspondant à la variable identifiante
        * voulue.
        */
        if (this.identifiantQuestionnaire) {
            // On charge le bon questionnaire
            const email = await this.authentificationService.getEmail() as string;
            this.rootForm = this.formulaireService.getRootFormByVariable(this.identifiantQuestionnaire);
            this.formulaireService.getRootForm().get('mailQuestionnaire').patchValue(email);
            // dans le cas d’une numéro de compostage, on met à jour le formulaire permettant de le choisir :
            let compteur = 0;
            this.variableIdentifiante.forEach((nomVariable) => {
                this.formulaireSelecteur.get(nomVariable).setValue(this.identifiantQuestionnaire[compteur]);
                compteur++;
            });

            // Désactivation des champs de sélection
            this.noCmpstAffiche = true;
        }

    }

    ongletPrecedent(): void {
        const elementTop: HTMLElement = document.getElementsByTagName('body')[0];
        this.index = this.index <= 0 ? 0 : this.index - 1;
        elementTop.scrollIntoView();
    }

    ongletSuivant(): void {
        const elementTop: HTMLElement = document.getElementsByTagName('body')[0];
        // RQ : Suivant le nombre d'onglets de l'enquete tester la valeur de l'index du dernier onglet sur ce qui suit...
        const nbOnglet = 9;
        this.index = this.index >= nbOnglet ? nbOnglet : this.index + 1;
        elementTop.scrollIntoView();
    }

    public get isDev(): boolean {
        return environment.dev;
    }

    get variableIdentifiante(): string[] {
        return variableIdentifiante;
    }

    public reinitialiserChampNoCmpst(sansConfirmation?: boolean) {
        if (sansConfirmation || confirm('Êtes-vous sûr de vouloir abandonner la saisie en cours ?')) {
            // reset du questionnaire
            this.formulaireSelecteur.reset();

            // Réactivation du champ de sélection noCmpst
            this.noCmpstAffiche = false;

            // Suppression du questionnaire
            this.rootForm = null;
            this.formulaireService.effacerQuestionnaire();
            this.index = 0;
            variableIdentifiante.forEach((nomVariable) => {
                this.formulaireSelecteur.get(nomVariable).setValue(null);
            });

            // LM : petit temps de latence pour pouvoir afficher les choix du select
            // Sur mon poste, ça ne marche pas sinon
            setTimeout(() => {
                // Juridiction
                document.getElementById('input-select-ielst').focus();
            }, 1000);
        }
    }

    public chargerQuestionnaireViaNoCmpst() {
        // Désactivation du champ noCmpst
        this.noCmpstAffiche = true;

        // Sélection de la valeur identifiant le questionnaire
        this.identifiantQuestionnaire = [];
        variableIdentifiante.forEach((nomVariable) => {
            this.identifiantQuestionnaire.push(this.formulaireSelecteur.get(nomVariable).value);
        });

        // Chargement du questionnaire par le numéro de compostage choisi
        this.rootForm = this.formulaireService.getRootFormByVariable(this.identifiantQuestionnaire);

        this.rootForm.get('ko').valueChanges.subscribe((result) => {
            if (result) {
                this.reinitialiserChampNoCmpst(true);
            }
        });

        setTimeout(() => {
            document.getElementById('xxContactNom').focus();
        }, 1000);
    }

    public clickTab(event: MatTabChangeEvent) {
        // quand on change d'onglet on met le focus sur le 1er champ de l'onglet pour faciliter la saisie au clavier
        const tab = this.index;

        switch (tab) {
            case 0: {
                setTimeout(() => {
                    document.getElementById('xxContactNom').focus();
                }, 1000);
                break;
            }
            case 1: {
                setTimeout(() => {
                    document.getElementById('aaNbCdiAav').focus();
                }, 1000);
                break;
            }
            case 2: {
                setTimeout(() => {
                    document.getElementById('bbPremContactOrigAsso').focus();
                }, 1000);
                break;
            }
            case 3: {
                setTimeout(() => {
                    document.getElementById('ccRecuVictNb').focus();
                }, 1000);
                break;
            }
            case 4: {
                setTimeout(() => {
                    document.getElementById('ddFaitPersoHomiVolo').focus();
                }, 1000);
                break;
            }
            case 5: {
                setTimeout(() => {
                    document.getElementById('eeEntretPsy').focus();
                }, 1000);
                break;
            }
            case 6: {
                // on fait rien = boucle bav
                break;
            }
            case 7: {
                // on fait rien car synthese en consultation
                break;
            }
            case 8: {
                setTimeout(() => {
                    document.getElementById('commentaire').focus();
                }, 1000);
                break;
            }
            default: {
                break;
            }
        }

        // on lance une sauvegarde automatique si on est un enquete en mode saisie
        if (!this.rolesService.isHabilite([RolesService.consultation.toLowerCase(), RolesService.gestionnaire.toLowerCase()])) {
            // On lance la synthese au cas où pas fait par l'utilisateur
            this.saisieService.majsSynthese(this.formulaireService.getRootForm().get('syntheseBav'), this.formulaireService.getRootForm().get('bav').get('detailBavs'));

            // Envoie des alertes à jour
            this.saisieService.getListeAlertesFormulaire(this.formulaireService.getRootForm());

            // Sauvegarde partielle
            this.formulaireService.sauvegarder().subscribe((ok) => {
                if (ok) {
                    // Finalement si tout est ok on laisse le questionnaire chargé en sauvegarde
                }
            });
        }
    }

}
